import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../Auth';
import { useTranslate } from 'react-polyglot';
import { useAxios } from '../../../AxiosHandler';
import Field from '../../Shared/Wizard/Field/Field';
import "./EventExternal.scss";
import { Card } from 'react-bootstrap';
import moment from 'moment';

function EventExternal(props) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    
    const [events, setEvents] = useState<Array<any>>([]);
    const [currentEvent, setCurrentEvent] = useState<any>();
    const [selected, setSelected] = useState("");
    const [resources, setResources] = useState<Array<any>>([]);
    const [guests, setGuests] = useState<Array<any>>([]);
    const [bookings, setBookings] = useState<Array<any>>([]);
    
    function updateSelection(id){
        setSelected(id);
        loadEvent(id);
    }
    
    function fetchData(){
        axios.all([
            axios.single({
                method: "get",
                url: "/api/users/externalaccess/",
                data: {},
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/resources",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
        ])
        .then((res) => {
            setEvents(res[0].data);
            setSelected(res[0].data[0]._id);
            setResources(res[1]["data"].sort((a,b) => (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0));
            
            loadEvent(res[0].data[0]._id);
        });
    }
    
    function loadEvent(id){
        axios.all([
            axios.single({
                method: "get",
                url: "/api/bookings/byEventId/" + id,
                data: {},
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/persons/byBooking/byEvent/" + id,
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/bookings/byEventId/" + id,
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
        ]).then((res) =>{
            setCurrentEvent(res[0].data[0]);
            setGuests(res[1].data);
            setBookings(res[2].data);
        });
    }
    
    function getBookingPlacements(person){
        let personBookings: any = [];
        
        for (const booking of bookings) {
            if (booking.guests.map(g => g._id).includes(person.toString())) {
                let bookingResources = resources.filter(r => booking.resources.map(b => b.resource).includes(r._id));
                for (const resource of bookingResources) {
                    for (const resourceBooking of resource.bookings) {
                        if (resourceBooking.people.includes(person.toString())) {
                            personBookings.push({
                                ...resourceBooking,
                                bookingtimes: resourceBooking.bookingtimes.filter(bt =>
                                    bt.people != undefined && bt.people.length != 0 ?
                                        bt.people?.includes(person.toString())// && bt.eventId == currentEvent._id.toString()
                                    : false
                                ),
                                resource: resource
                            });
                        }
                    }
                }
            }
        }
        
        return <table className="table table-notstriped">
            <tbody>
                {personBookings.map((x, key) => 
                    <tr key={key}>
                        <td>{t("eventexternal.room") + ": " + x.resource.name}</td>
                        <td>
                            {x.bookingtimes.map((y, key2) => {
                                let start = moment(y.start);
                                let end = moment(y.end);
                                let diffYear = false;
                                if (start.get('year') != end.get('year')) {
                                    diffYear = true;
                                }

                                return <p style={{
                                        margin: "0px",
                                    }}>
                                        {diffYear ? start.format("DD.MM.yyyy") + " -> " + end.format("DD.MM.yyyy") : start.format("DD.MM") + " -> " + end.format("DD.MM")}
                                    </p>
                            })}
                        </td>
                    </tr>
                )}
            </tbody>
        </table>;
    }
    
    useEffect(() => {
        fetchData();
    }, []);
    
    useEffect(() => {
        
    }, [guests]);

    return (
        <div className='maincontent'>
            <div className='eventexternal'>
                <div className="pagetitle-container">
                    <h1>{t("eventexternal.page_name")}</h1>
                    <h2>{currentEvent?.eventReadable ?? t("eventexternal.loading")}</h2>
                </div>
                <div className="eventselector">
                    <Field
                        type="select"
                        //title={t("title")}
                        value={{ value: selected }}
                        options={{
                            //choosetext: t("choosetext"),
                            choices: events.map(x => { return { value: x._id, label: x.name } })
                        }}
                        onChange={val => updateSelection(val.value)}
                    />
                </div>
                <Card>
                    <Card.Body>
                        <h3>{t("eventexternal.guests")}</h3>
                        <hr/>
                        <table className="table table-sm table-striped">
                            <thead>
                                <tr>
                                    <td>{t("eventexternal.guestname")}</td>
                                    <td>{t("eventexternal.customer")}</td>
                                    <td>{t("eventexternal.bookings")}</td>
                                </tr>
                            </thead>
                            <tbody>
                                {guests.map((person, key) => 
                                    <tr>
                                        <td>{person.firstname + " " + person.lastname}</td>
                                        <td>{person.organization}</td>
                                        <td>{getBookingPlacements(person._id)}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default EventExternal;

